export default __webpack_public_path__ + "static/media/6c.f7aeff29.svg";